// Хук сцены: возвращает игровой контроллер из модульного хранилища preloadedGame.
// Обновляет сцену при загрузке или очистке контроллера, не помещая его в Redux.

import { useSyncExternalStore } from 'react'
import { getPreloadedGameWrapper, subscribePreloadedGames } from '../utils/game/preloadedGame'

// При статической генерации игровой контроллер ещё не создан.
const getServerSnapshot = () => null

// Обновляет сцену при изменении контроллера, не помещая его в Redux.
export function usePreloadedGameWrapper(game) {
  return useSyncExternalStore(
    subscribePreloadedGames,
    () => getPreloadedGameWrapper(game),
    getServerSnapshot,
  )
}
